import { INBOX_INTERVAL_PROD, ImproverAngularEnvironment, createServices } from '@improver/app-config/environments';

// PROD environment
export const environment: ImproverAngularEnvironment = {
  services: createServices(),
  debugBar: false,
  htmlElementIdRegistration: false,
  inboxCallInterval: INBOX_INTERVAL_PROD,
  instanceSubdomains: true,
  production: true,
  translationsEnabled: true,
  zendeskHost: 'improver.zendesk.com',
  ckEditorLicence:
    'eyJhbGciOiJFUzI1NiJ9.eyJleHAiOjE4MTg5NzkxOTksImp0aSI6IjUwMzViOGFkLWMyOTgtNGU3MS04MjdlLThjYjAyNDQ3Y2YyZiIsImRpc3RyaWJ1dGlvbkNoYW5uZWwiOlsic2giLCJkcnVwYWwiXSwid2hpdGVMYWJlbCI6dHJ1ZSwiZmVhdHVyZXMiOlsiRFJVUCIsIkRPIiwiRlAiLCJTQyIsIlRPQyIsIlRQTCIsIlBPRSIsIkNDIiwiTUYiLCJTRUUiLCJFQ0giLCJFSVMiLCJMSCIsIkZPTyIsIkZJIl0sInZjIjoiZTAyZDMzNmIifQ.mX2vifTDCT2thf63xDUe_LOawiuRb-a7p70d__yMJRzhBNZdliYIXqP-byWtyVTzS4UQ7wUNLmbyqBN3isGgYg',
};
